import { Link } from "@chakra-ui/react";

import { privacyTermsURL, serviceTermsURL } from "./fixtures";

export const knowledgeAgreement = () => {
  return (
    <span>
      Potwierdzam, że zapoznałem się z{" "}
      <Link
        target="_blank"
        href={serviceTermsURL}
        textDecor="underline"
        isExternal
      >
        Regulaminem Serwisu
      </Link>{" "}
      oraz{" "}
      <Link
        target="_blank"
        href={privacyTermsURL}
        textDecor="underline"
        isExternal
      >
        Polityką Prywatności
      </Link>
      .
    </span>
  );
};
